var active_filters = [];

var nav_open = false;
var active_filter_section = false;


var filterBox, 
    date_trig, 
    venue_trig,
    category_trig,
    search_trig,
    program, 
    filter_sections, 
    activeFiltersDom,
    events_wrap,
    trigs,
    events, 
    noResults, 
    searchBar;

document.body.addEventListener('click', function(e){
    if(filterBox && filterBox.classList.contains('open')){
        e.preventDefault();
        nav_open = false;
        active_filter_section = false;
        filterBox.classList.remove('open');
        for (let a = 0; a < trigs.length; a++) {
            trigs[a].classList.remove('active');
        }
        for (let a = 0; a < filter_sections.length; a++) {
            filter_sections[a].classList.remove('vis');
        }
    }
});

function bind_filters(){


    filterBox = document.querySelector('.filters');
    
    if(filterBox){
        date_trig = filterBox.querySelector('.filter-date');
        venue_trig = filterBox.querySelector('.filter-venue-button');
        category_trig = filterBox.querySelector('.filter-category-button');
        program = document.querySelector('.programme');
        filter_sections =  filterBox.querySelectorAll('.filter-section');
        activeFiltersDom = document.querySelector('.active-filters');
        events_wrap = document.querySelector('.events-wrap');
        trigs = filterBox.querySelectorAll('.filter-button');
        events = document.querySelectorAll('.program-event');
        noResults = document.querySelector('.no-results');
        search_trig = document.querySelector('.filter-search-button');
        searchBar = document.querySelector('.search-field');

        filterBox.addEventListener('click', function(e) {
            e.stopPropagation();
        });

        filter_nav();
        date_filter();
        venue_filter();
        search_filter();
        category_filter();
    }

};

function search_filter(){


    search_trig.addEventListener('click', function(){
        console.log()
    });


    var query = '';
    function debounce(func, delay) {
        let timeout;
     
        return function (...args) {
          clearTimeout(timeout);
          timeout = setTimeout(() => func.apply(this, args), delay);
        };

    }

    function handleKeyUp(event) {
        query = searchBar.value;
 
        let querys = document.querySelectorAll('.search-query');
        for (let a = 0; a < querys.length; a++) {
            const element = querys[a];
            element.parentNode.removeChild(element);
        }

        if(query.length){

            active_filters.push(`filter-search-no-results`);
     
            let htmlElm = document.createElement('h3');
            htmlElm.setAttribute('data-filter', query);
            htmlElm.classList.add('search-query')
            htmlElm.innerHTML = wrapWordsWithRotation(query, false);
                
            addRandomStyles(htmlElm);


            setTimeout(function(){
                htmlElm.style.opacity = '1';
            }, 10);

            activeFiltersDom.appendChild(htmlElm);
            htmlElm.addEventListener('click', remove_filter);

        }else{
            active_filters = active_filters.filter(value => 
                !value.toLowerCase().includes('filter-search')
            );
        }


    };

    searchBar.addEventListener('keyup', handleKeyUp); 
    searchBar.addEventListener('keyup', debounce(handleDebouncedSearch, 300));

    function handleDebouncedSearch(){
    
        if(query.length > 0){
   
            const path =  `programme/search?q=${query}`;

            fetch(path).then(function(response) {
                return response.json();
            })
            .then(function(data) {

                active_filters = active_filters.filter(value => 
                    !value.toLowerCase().includes('filter-search')
                );

                if(data.length){
                    
                    for (let a = 0; a < data.length; a++) {
                        const id = data[a];
                        active_filters.push(`filter-search-${id}`);
                
                    }
                    
                }else{
                    active_filters.push(`filter-search-no-results`);
                }

                if(active_filters.join().includes('filter-search-')){
                    category_trig.classList.add('in-use');
                }else{
                    category_trig.classList.remove('in-use');
                }

                update_filters();

                
            })
            .catch(function(error) {
                console.error('Error:', error);
            });

        }else{

            let querys = document.querySelectorAll('.search-query');
            for (let a = 0; a < querys.length; a++) {
                const element = querys[a];
                element.parentNode.removeChild(element);
            }

            active_filters = active_filters.filter(value => 
                !value.toLowerCase().includes('filter-search')
            );


            update_filters();
            
        }
     
    }

};

function filter_nav(){

    for (let a = 0; a < trigs.length; a++) {
        const elm = trigs[a];

        elm.addEventListener('click', function(e){

            e.preventDefault();


            let section = elm.dataset.filter;

            for (let a = 0; a < filter_sections.length; a++) {
                filter_sections[a].classList.remove('vis');
            }

            let activeSection = document.querySelector(`.${section}-filter`);
           
            if(activeSection){
                activeSection.classList.add('vis');
            }
            
            if(nav_open && section == active_filter_section){
                   
                    filterBox.classList.remove('open');
                    
                    for (let a = 0; a < trigs.length; a++) {
                        trigs[a].classList.remove('active');
                    }

                    nav_open = false;
                    active_filter_section = false;

                    for (let a = 0; a < filter_sections.length; a++) {
                        filter_sections[a].classList.remove('vis');
                    }
                    
                    if(elm.classList.contains('filter-search-button')){
                        searchBar.blur();
                    }

            }else{

                if(elm.classList.contains('filter-search-button')){
                    searchBar.focus();
                }

                filterBox.classList.add('open');
                
                for (let a = 0; a < trigs.length; a++) {
                    trigs[a].classList.remove('active');
                }

                elm.classList.add('active');

                nav_open = true;
                active_filter_section = section
                
            
            }
            
            

        });
        
    }

};

function category_filter(){
    
    const dates = filterBox.querySelectorAll('.filter-category');

    for (let a = 0; a < dates.length; a++) {

        const elm = dates[a];

        elm.addEventListener('click', function(e){

            let data = elm.dataset.category;
            let filter = 'filter-category-' + data;

            if(active_filters.includes(filter)){

                let html = document.querySelector(`[data-html="filter-icon-${data}"]`);
                html.parentElement.removeChild(html);

                removeItem(active_filters, filter);
                elm.classList.remove('selected');
                
            }else{

                active_filters.push(filter);
                
                let htmlElm = document.createElement('h3');

                htmlElm.setAttribute('data-html', 'filter-icon-'+data);
                htmlElm.setAttribute('data-filter', filter);

                htmlElm.innerHTML = wrapWordsWithRotation(elm.firstElementChild.innerHTML, true);

                if(document.querySelector('.'+filter+'-svg')){
                   
                    var clonedElement = document.querySelector('.'+filter+'-svg').cloneNode(true);
                   
                    // const rotation = Math.floor(Math.random() * 40) - 20;
                    const rotation = 0;
                    const marginX = Math.floor(Math.random() * 10) - 6;
                    const marginY = Math.floor(Math.random() * 10) - 5;
                    const width  = Math.floor(Math.random() * 4) + 8;

                    clonedElement.style.transform =   `rotate(${rotation}deg) scale(0)`;
                    clonedElement.style.margin = marginX +'px ' + marginY + 'px';
                    clonedElement.style.width = width + 'vw';
                    clonedElement.style.display = 'block';

                    let ranIndex = Math.round(Math.random() * htmlElm.childNodes.length);
                    if(ranIndex == 0){
                        htmlElm.prepend(clonedElement);
                    }else if(htmlElm.childNodes[ranIndex]){
                        htmlElm.insertBefore(clonedElement, htmlElm.childNodes[ranIndex]);
                    }else{
                        htmlElm.append(clonedElement);
                    }

            
                    setTimeout(function(){
                        clonedElement.style.transform =   `rotate(${rotation}deg)`;
                    }, 100);

                }

                setTimeout(function(){
                    htmlElm.style.opacity = '1';
                }, 10);
     
                addRandomStyles(htmlElm);

                activeFiltersDom.appendChild(htmlElm);
                htmlElm.addEventListener('click', remove_filter);

                elm.classList.add('selected');
            }

            if(active_filters.join().includes('filter-category-')){
                category_trig.classList.add('in-use');
             }else{
                category_trig.classList.remove('in-use');
             }
 
             update_filters();

        });
    
    }
};

function venue_filter(){

    const dates = filterBox.querySelectorAll('.filter-venue');
    for (let a = 0; a < dates.length; a++) {

        const elm = dates[a];

        elm.addEventListener('click', function(e){

            let data = elm.dataset.venue;
            let filter = 'filter-venue-' + data;

            if(active_filters.includes(filter)){

                let html = document.querySelector(`[data-html="filter-icon-${data}"]`);
                html.parentElement.removeChild(html);

                removeItem(active_filters, filter);
                elm.classList.remove('selected');
                
            }else{

                active_filters.push(filter);
                
                let htmlElm = document.createElement('h3');
                htmlElm.setAttribute('data-html', 'filter-icon-'+data);
                htmlElm.setAttribute('data-filter', filter);
                htmlElm.innerHTML = wrapWordsWithRotation(elm.firstElementChild.innerHTML, false);
                
                // var close = document.createElement('div');
                // close.innerHTML = '+';

                // htmlElm.appendChild(close);

                addRandomStyles(htmlElm);

                activeFiltersDom.appendChild(htmlElm);
                htmlElm.addEventListener('click', remove_filter);

                elm.classList.add('selected');

                setTimeout(function(){
                    htmlElm.style.opacity = '1';
                }, 10);
            }

            if(active_filters.join().includes('filter-venue-')){
                venue_trig.classList.add('in-use');
             }else{
                venue_trig.classList.remove('in-use');
             }

             
 
             update_filters();

        });
    
    }
};

function date_filter(){

    const dates = filterBox.querySelectorAll('.filter-day.available');

    for (let a = 0; a < dates.length; a++) {

        const elm = dates[a];

        elm.addEventListener('click', function(e){

            e.preventDefault();

            let data = elm.dataset.date;
            let filter = 'filter-date-' + data;
            
            if(active_filters.includes(filter)){

                let html = document.querySelector(`[data-html="filter-icon-${data}"]`);
                html.parentElement.removeChild(html);

                removeItem(active_filters, filter);
                elm.classList.remove('selected');
                
            }else{

                active_filters.push(filter);
                
                let html = document.querySelector(`[data-html="${data}"]`);
                var clonedElement = html.cloneNode(true);
                clonedElement.setAttribute('data-html', 'filter-icon-'+data);
                clonedElement.setAttribute('data-filter', filter);
                
                // var close = document.createElement('div');
                // close.innerHTML = '+';

                // clonedElement.appendChild(close);

                addRandomStyles(clonedElement);

                activeFiltersDom.appendChild(clonedElement);
                clonedElement.addEventListener('click', remove_filter);

                elm.classList.add('selected');

                setTimeout(function(){
                    clonedElement.style.opacity = '1';
                }, 10);
            }

            // brrrrr its cold in here
            elm.classList.add('shiver');

            setTimeout(function(){
                elm.classList.remove('shiver');
            }, 600);

            
            // check that if a the date filter type is in the active arry 

            if(active_filters.join().includes('filter-date-')){
               date_trig.classList.add('in-use');
            }else{
               date_trig.classList.remove('in-use');
            }

            update_filters();

        });
    }

};

function remove_filter(e){
    e.preventDefault();
    e.stopPropagation();

    let elm = this;
    let filter = elm.dataset.filter;

    elm.parentElement.removeChild(elm);

    removeItem(active_filters, filter);

    filterBox.querySelector('.'+filter).classList.remove('selected');

    if(active_filters.join().includes('filter-date-')){
        date_trig.classList.add('in-use');
     }else{
        date_trig.classList.remove('in-use');
     }

    if(active_filters.join().includes('filter-venue-')){
        venue_trig.classList.add('in-use');
    }else{
        venue_trig.classList.remove('in-use');
    }

    if(active_filters.join().includes('filter-category-')){
        category_trig.classList.add('in-use');
    }else{
        category_trig.classList.remove('in-use');
    }

    update_filters();

};



function update_filters(){

    if(active_filters.length > 0){
        program.classList.add('filterd');
    }else{
        program.classList.remove('filterd');
    }

    var arry_split = [];

    for (let a = 0; a < active_filters.length; a++) {
        let group = splitAtSecondDash(active_filters[a])[0];
        if(!arry_split[group]){
            arry_split[group] = [];
        }
        arry_split[group].push(active_filters[a]);
    }

    let results = [];

    for (var key in arry_split) {
        let round_results = [];

        for (let a = 0; a < arry_split[key].length; a++) {

            let filt = arry_split[key][a];
            // console.log(events_wrap);
            let filterd = events_wrap.querySelectorAll('.'+filt);

            for (let b = 0; b < filterd.length; b++) {
                if(!round_results.includes(filterd[b])){
                    round_results.push(filterd[b]);
                }
            }
        }

        if(results.length > 0){
            results = commonElements(results, round_results);
        }else{
            results = round_results;
        }
    }

    if(active_filters.length < 1){
        
        for (let a = 0; a < events.length; a++) {
            const elm = events[a];
            elm.classList.remove('hidden');    
        }
        
        noResults.classList.remove('showing');

    }else{

        window.scrollTo(0, 0);

        for (let a = 0; a < events.length; a++) {

            const elm = events[a];
            if(results.includes(elm)){
                elm.classList.remove('hidden');
            }else{
                elm.classList.add('hidden');
            }
            
        }

        if(results.length < 1){
            noResults.classList.add('showing');
        }else{
            noResults.classList.remove('showing');
        }

    }

   

    
   
}

export default bind_filters;



function removeItem(array, item) {
    var i = array.length;
  
    while (i--) {
      if (array[i] === item) {
        array.splice(i, 1);
      }
    }
  }
  
  function addRandomStyles(elm) {
 
    var randomMargin = Math.floor(Math.random() * (20 - 10 + 1) + 10);
    elm.style.padding = randomMargin + 'px';

    var randomRotation = Math.floor(Math.random() * (4 - (-4) + 1) + (-4));
    randomRotation = 0;

    elm.style.transform = 'rotate(' + randomRotation + 'deg)';

  }



  function wrapWordsWithRotation(text, background) {
    const words = text.split(" ");
    let wrappedText = "";7
  
    for (let i = 0; i < words.length; i++) {
    //   const rotation = Math.floor(Math.random() * 10) - 5; // Random rotation between -3 and 3
      const rotation = 0;
      let bgColour = 'transparent';
      let textCol = '#1B1C1C';
      if(background){
        bgColour = 'transparent'
        textCol = '#1B1C1C';
      }
      
      wrappedText += `<span style="color: ${textCol}; background: ${bgColour}; transform: rotate(${rotation}deg); display: inline-block;">${words[i]}</span> `;
    }
  
    return wrappedText.trim();
  }

  function splitAtSecondDash(str) {
    const firstDashIndex = str.indexOf('-');
    const secondDashIndex = str.indexOf('-', firstDashIndex + 1);
    
    if (secondDashIndex !== -1) {
        const firstPart = str.slice(0, secondDashIndex);
        const secondPart = str.slice(secondDashIndex + 1);
        return [firstPart, secondPart];
    } else {
        return ["", str]; // If there's no second dash, return an empty string as the first part
    }
}


function commonElements(arr1, arr2) {
    // Use the filter method to create a new array containing common elements
    const common = arr1.filter(element => arr2.includes(element));
  
    return common;
  }